import React, { useState } from 'react';
import { useGameContext } from '../contexts/GameContext';
import kinksData from '../kinks.json';

const GameSetup = ({ setGameMode }) => {
  const {
    playerNames,
    setPlayerNames,
    startingLevel,
    setStartingLevel,
    roundsPerLevel,
    setRoundsPerLevel,
    generateCardOptions,
    rejectedKinks,
    setRejectedKinks
  } = useGameContext();

  const [showKinkSettings, setShowKinkSettings] = useState(false);

  const startWheelMode = () => {
    setGameMode('wheel');
  };

  const startCardsMode = () => {
    setGameMode('cards');
    generateCardOptions();
  };

  const toggleKink = (kink) => {
    if (rejectedKinks.includes(kink)) {
      // Remove from rejected kinks
      setRejectedKinks(rejectedKinks.filter(k => k !== kink));
    } else {
      // Add to rejected kinks
      setRejectedKinks([...rejectedKinks, kink]);
    }
  };

  // Get unique kinks from kinksData
  const allKinks = Object.entries(kinksData);

  return (
    <div className="game-setup">
      <h2>Game Setup</h2>

      <div className="input-group">
        <label>Your Name:</label>
        <input
          type="text"
          value={playerNames.player1}
          onChange={(e) => setPlayerNames({...playerNames, player1: e.target.value})}
          placeholder="Your name"
        />
      </div>

      <div className="input-group">
        <label>Your Wife's Name:</label>
        <input
          type="text"
          value={playerNames.player2}
          onChange={(e) => setPlayerNames({...playerNames, player2: e.target.value})}
          placeholder="Your wife's name"
        />
      </div>

      <div className="input-group">
        <label>Starting Level (1-5):</label>
        <input
          type="number"
          min="1"
          max="5"
          value={startingLevel}
          onChange={(e) => setStartingLevel(parseInt(e.target.value))}
        />
      </div>

      <div className="input-group">
        <label>Rounds Per Level:</label>
        <input
          type="number"
          min="1"
          value={roundsPerLevel}
          onChange={(e) => setRoundsPerLevel(parseInt(e.target.value))}
        />
      </div>

      <div className="kink-settings">
        <button
          onClick={() => setShowKinkSettings(!showKinkSettings)}
          className="toggle-kinks-button"
        >
          {showKinkSettings ? 'Hide Kink Preferences' : 'Manage Kink Preferences'}
        </button>

        {showKinkSettings && (
          <div className="kink-list">
            <h3>Manage Kink Preferences</h3>
            <p>Uncheck the kinks you want to exclude from the game:</p>
            <div className="kink-checkboxes">
              {allKinks.map(([id, kink]) => (
                <div key={id} className="kink-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={!rejectedKinks.includes(id)}
                      onChange={() => toggleKink(id)}
                    />
                    {kink.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="game-mode-selection">
        <h3>Select Game Mode</h3>
        <button onClick={startWheelMode} className="game-mode-button">
          Wheel of Fortune
        </button>
        <button onClick={startCardsMode} className="game-mode-button">
          Four Cards
        </button>
      </div>
    </div>
  );
};

export default GameSetup;
